import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import DashboardDetailsMarketingHelp from '../DashboardDetailsMarketingHelp/DashboardDetailsMarketingHelp';
import { dashboardCrumbs, DashboardCrumbs } from '../../constants/dashboard';
import DashboardDetailsCrumbs from '../../containers/DashboardDetailsCrumbs/DashboardDetailsCrumbs';
import DashboardDetailsGraph from '../../containers/DashboardDetailsGraph/DashboardDetailsGraph';
import { dashboardStore } from '../../store/dashboardStore';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import Crumbs from '~/view/components/Controls/Crumbs';
import './style.scss';

const DashboardDetails: FC = observer((): ReactElement | null => {
  const onSelectCrumb = useCallback((section: DashboardCrumbs) => {
    dashboardStore.selectCrumb(section);
  }, []);

  if (!dashboardStore.selectedCrumb) return null;

  return (
    <div className="dashboard-details">
      <Crumbs crumbs={dashboardCrumbs} activeCrumb={dashboardStore.selectedCrumb} onClick={onSelectCrumb} translateLabel />

      <div className="d-flex flex-row gap-40">
        <DashboardDetailsCrumbs />
        <DashboardDetailsGraph />
        <DashboardDetailsMarketingHelp />
      </div>

      <LoadingOverlay visible={dashboardStore.isReportLoading} refreshing />
    </div>
  );
});

export default DashboardDetails;
